import React, { useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { FaHome, FaUsers, FaFileAlt, FaChartBar, FaTimes, FaBars, FaAngleUp, FaAngleDown, FaFileImage, FaFileAudio  } from "react-icons/fa";
import "./TeacherDashboard.css";

const menuItems = [
  {
    label: "Dashboard",
    icon: <FaHome />,
    section: "dashboard/teacher",
  },
  {
    label: "Documents ",
    icon: <FaFileAlt />,
    children: [
      { label: "Scan Doc", section: "dashboard/teacher/scan" },
      { label: "My Docs", section: "dashboard/teacher/document" },
    ],
  },
  {
    label: "Excercise Docs ",
    icon: <FaFileImage  />,
    children: [
      { label: "Upload Img Doc", section: "dashboard/teacher/scan-image" },
      { label: "My Docs", section: "dashboard/teacher/document-image" },
    ],
  },
  {
    label: "Audio Exercises ",
    icon: <FaFileAudio  />,
    children: [
      { label: "Upload Audio Doc", section: "dashboard/teacher/scan-audio" },
      { label: "My Docs", section: "dashboard/teacher/audio-exercise-levels" },
    ],
  },
  {
    label: "Students",
    icon: <FaUsers />,
    section: "dashboard/teacher/students",
  },
  {
    label: "Analytics",
    icon: <FaChartBar />,
    section: "dashboard/teacher/analytics",
  },
];

function TeacherDashboard({ user }) {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
  const [openDropdowns, setOpenDropdowns] = useState({}); // Track open dropdowns by label
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [activeSection]);

  const fetchData = async () => {
    // setLoading(true);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSectionChange = (section) => {
    setActiveSection(section);
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
    navigate(`/${section}`);
  };

  const handleDropdownToggle = (label) => {
    setOpenDropdowns((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // Helper to check if a section is active (for parent with children)
  const isParentActive = (children) => {
    return children?.some((child) => activeSection === child.section);
  };

  return (
    <div className={`teacher-dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
      {/* Toggle Sidebar Button */}
      <button className="toggle-sidebar-mobile" onClick={toggleSidebar}>
        {sidebarOpen ? "" : <FaBars />}
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <h3>Teacher Panel</h3>
          <button className="close-sidebar" onClick={toggleSidebar}>
            <FaTimes />
          </button>
        </div>

        <div className="sidebar-content">
          <div className="user-info">
            <div className="avatar">{user.username.charAt(0).toUpperCase()}</div>
            <div className="user-details">
              <h4>{user.username}</h4>
              <p>{user.email}</p>
            </div>
          </div>

          <nav className="sidebar-nav">
            <ul>
              {menuItems.map((item) => (
                <li key={item.label} className={item.children ? (isParentActive(item.children) ? "act dropdown" : "dropdown") : activeSection === item.section ? "active" : ""}>
                  {item.children ? (
                    <>
                      <button type="button" onClick={() => handleDropdownToggle(item.label)}>
                        {item.icon} {item.label} {"  "} {openDropdowns[item.label] ? <FaAngleUp /> : <FaAngleDown  />}
                      </button>
                      {openDropdowns[item.label] && (
                        <ul className="dropdown-menu">
                          {item.children.map((child) => (
                            <li key={child.label} className={activeSection === child.section ? "active" : ""}>
                              <button onClick={() => handleSectionChange(child.section)}>{child.label}</button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    <button onClick={() => handleSectionChange(item.section)}>
                      {item.icon} {item.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default TeacherDashboard;
